import { useState, useEffect} from "react";
import Sider from "./sidebar";
import Main from "./main";
import { useMediaQuery } from "react-responsive";
import { ErrorProvider } from "../../utils/context/error"
import Toasts from "../toast";
import Icon from "../../Icons/menu/Icon";
import Navbar from "./navbar";
import DatosEmpresa from "./bussines";
import clsx from "clsx";
//import { BreadProvider } from "../../../utils/context/breadcrum";

function Home() {
  const [showToast, setShowToast] = useState(false);
  const [opciones, setOpciones] = useState([]);
  const [sede, setSede] = useState("No Sede");
  const [empresa, setEmpresa] = useState("No Empresa");
  let isTabletMid = useMediaQuery({ query: "(min-width: 768px)" });
  const [expand, setExpand] = useState(isTabletMid ? true : false);
  
  const expandSidebar = () => {
    if (expand) 
       setExpand(false)
    else
       setExpand(true)
  }

  useEffect(() => {
       if (isTabletMid)
         setExpand(true)
       else
         setExpand(false);
  }, [isTabletMid]);
    
  return (
    <ErrorProvider value={{ showToast, opciones, setShowToast, setOpciones }}>
     <>
     <div className="flex flex-col w-full h-screen overflow-hidden">
       <div className="flex flex-row justify-center">
           <div className={clsx(' flex h-[3rem] bg-sidebar transition-all duration-300 ease-in-out',
                                 expand && isTabletMid ? 'justify-between w-[4rem] md:w-[15rem] 2xl:w-[15rem]' : 'justify-center w-[4rem]')}>
                {expand && isTabletMid && (
                    <div className="flex flex-1 items-center justify-center h-full w-full mt-1 text-center border-b-[0.1rem] md:border-[#7C284D]">
                      <DatosEmpresa NombreEmp={empresa} NombreSede={sede} />
                   </div>
                )}
               <div className={clsx('flex items-center justify-center h-full', expand && isTabletMid ? 'ml-2 mr-2':'')}>
                  <i onClick={expandSidebar}>
                    <Icon
                       svg="bars"
                       className="w-[1.5rem] h-[1.5rem] text-textsidebar fill-current hover:text-white hover:cursor-pointer transition-colors duration-200"
                       title="bars"
                    />
                 </i>
               </div>
           </div>
           <div className="flex-1 h-[3rem]">
             <Navbar/>
           </div>
        </div>  
        <div className="flex flex-row">
           <Sider expand={expand} setSede={setSede} setEmpresa={setEmpresa}/>
           <Main></Main>
        </div>
     </div>
     {showToast && (
        <Toasts
          type={opciones.type}
          message={opciones.message}
          active={opciones.active}
        ></Toasts>
      )}
      </>
    </ErrorProvider>
  );
}

export default Home;
